/**
 * Different types of Priority.
 * @public
 */
enum Priority {
	/**
	 * High priority.
	 * @public
	 */
	High = "High",

	/**
	 * Medium priority.
	 * @public
	 */
	Medium = "Medium",

	/**
	 * Low priority.
	 * @public
	 */
	Low = "Low",

	/**
	 * Default, none priority.
	 * @public
	 */
	None = "None",
}

export default Priority;
